import api from './api';

export const authService = {
  async login(email, password) {
    try {
      const response = await api.post('/auth/login', { email, password });
      const { token, user } = response.data;
      localStorage.setItem('auth_token', token);
      return { token, customer: { id: user.id, name: user.name, email: user.email } };
    } catch (error) {
      // Re-throw the error so the calling code can handle it properly
      throw error;
    }
  },
  
  async logout() {
    try { 
      await api.post('/auth/logout'); 
    } catch (e) {
      console.warn('Logout API call failed, but continuing with local cleanup');
    }
    localStorage.removeItem('auth_token');
    return { message: 'Logged out successfully' };
  },
  
  async refreshToken() {
    try {
      const response = await api.get('/auth/refresh');
      return response.data;
    } catch (error) {
      console.warn('Token refresh failed, user may need to login again');
      throw error;
    }
  },
  
  async getCurrentUser() {
    const response = await api.get('/profile');
    return response.data.user;
  },

  async getUserAndPractices() {
    const response = await api.get('/profile');
    return {
      user: response.data.user,
      integrations: response.data.integrations || []
    };
  },

  async getIntegrations() {
    const response = await api.get('/dashboard/integrations');
    return {
      integrations: response.data.integrations || [],
      warnings: response.data.warnings || []
    };
  },
  
  async forgotPassword(email) {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },
  
  async resetPassword(token, newPassword) {
    const response = await api.post('/auth/reset-password', { 
      token, 
      newPassword 
    });
    return response.data;
  },
  
  async changePassword(currentPassword, newPassword) {
    const response = await api.post('/auth/change-password', {
      currentPassword,
      newPassword
    });
    return response.data;
  }
};
